import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import CloseButton from '../../../common/CloseButton';
import moment from 'moment';
import { captureException } from '@sentry/react';
import { s3Link } from '../../../utils/constants';
import { Spinner } from 'react-bootstrap';
import currency from 'currency.js';
import useDidMountEffect from '../../../utils/useDidMountEffect';

const PpvStatistics = ({
    handleStatsModal,
    showStatsModal,
    ppvFilter,
    setPpvFilter,
    active,
    statsLogin,
    statsType,
    fetchPpvListTrigger
}) => {
    const [isBusy, setIsBusy] = useState(false);
    const [ppvTotal, setPpvTotal] = useState(0);
    // const [totalPpv, setTotalPpv] = useState(0);
    const [ppvList, setPpvList] = useState([]);

    const updatePpvFilter = (e) => {
        setPpvList([]);
        setPpvFilter(e.target.value);
        fetchPpvList(e.target.value);
    };

    const getMyFunds = async () => {
        await axios.get('/api/performances/my-funds')
            .then(response => {
                let tempPpv = 0;
                const myFunds = response.data;
                Object.keys(myFunds).forEach(fundKey => {
                    tempPpv += myFunds[fundKey].reduce((sum, fund) => {
                        if (fund.transaction_type == 'PPV') {
                            return sum += fund.total == null ? 0 : parseFloat(fund.total);
                        }
                        return sum;
                    }, 0);
                });
                // setPpvTotal(tempPpv);
                // setTotalPpv(tempPpv);
            }).catch(error => {
                captureException(error);
            });
    };

    const fetchPpvList = async (filter = '') => {
        setIsBusy(true);
        const formData = new FormData();
        if (filter != '') {
            if (filter == 'single')
                formData.append('ppv_filter', 'all_su');
            else if (filter == 'all')
                formData.append('ppv_filter', 'top_earners');
            else
                formData.append('ppv_filter', filter);
        } else
            formData.append('ppv_filter', ppvFilter);

        if (filter != '') {
            if (filter == 'single' || filter == 'all_su' || filter == '30_days_su')
                formData.append('suid', active);
        } else {
            if (ppvFilter == '30_days_su' || ppvFilter == 'all_su' || ppvFilter == '')
                formData.append('suid', active);
        }

        await axios({
            method: 'post',
            url: '/api/top-ppvs',
            data: formData
        })
            .then((response) => {
                if (response.data.success === true) {
                    setPpvList(response.data.ppvs);
                    setPpvTotal(parseFloat(response.data.total_ppv));
                }

                setIsBusy(false);
            })
            .catch((error) => {
                captureException(error);
                setIsBusy(false);
            });
    };

    useEffect(() => {
        if (showStatsModal) {
            getMyFunds();
            fetchPpvList();
        }
    }, [showStatsModal]);

    useDidMountEffect(() => {
        fetchPpvList(fetchPpvListTrigger);
    }, [fetchPpvListTrigger]);

    return <Modal
        show={showStatsModal}
        onHide={handleStatsModal}
        className="stats-modal"
        centered
        size="l"
    >
        <Modal.Header>
            <CloseButton
                className="close"
                onClick={handleStatsModal}
                style={{ position: 'absolute', top: '32px', right: '12px' }}
            />
            <Modal.Title>{statsLogin ? 'PPVs Purchased by ' + statsLogin : 'PPV STATISTICS'}</Modal.Title>

            <div className="top-ppv-header-right" style={{ marginRight: '35px' }}>
                {statsType != 'single' &&
                    <div className="ppv-filters-all">
                        <span style={{ display: 'none' }}><input type="radio" value="last_30_days" checked={ppvFilter === "last_30_days"} onChange={updatePpvFilter} /> Last 30 days</span>
                        <span><input type="radio" value="top_qty" checked={ppvFilter === "top_qty"} onChange={updatePpvFilter} /> Top Qty</span>
                        <span><input type="radio" value="top_earners" checked={ppvFilter === "top_earners"} onChange={updatePpvFilter} /> Top Earners</span>
                    </div>
                }
                {statsType == 'single' &&
                    <div className="ppv-filter-su">
                        <span style={{ display: 'none' }}><input type="radio" value="30_days_su" checked={ppvFilter === "30_days_su"} onChange={updatePpvFilter} /> 30 days</span>
                        <span><input type="radio" value="all_su" checked={ppvFilter === "all_su"} onChange={updatePpvFilter} /> All</span>
                    </div>
                }
                <div className="clear_b"></div>
            </div>

        </Modal.Header>
        <Modal.Body style={{ minHeight: '90' }}>
            <div className="stats-cont">
                <div className="main_ppv_cont">
                    <div className="total_ppv_cont">
                        <span className="top_ppv_total">
                            <b>Total PPV Net Earnings: {currency(ppvTotal).format({ precision: 2 })}</b>
                        </span>
                    </div>
                    <div className="top_ppv_tbl_cont">
                        <table width="100%" className="top_ppv_tbl">
                            <thead>
                                <tr className="ppv_tbl_header">
                                    <th className="text_center"><b>Media</b></th>
                                    {
                                        (ppvFilter == 'all_su') ? <th className="text_right"><b>Paid</b></th>
                                            : <>
                                                <th className="text_right"><b>Total</b></th>
                                                <th className="text_right"><b>Qty</b></th>
                                                <th className="text_right"><b>Price</b></th>
                                            </>
                                    }
                                    <th className="text_center"><b>Date</b></th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                isBusy ? <div className='text-center'><Spinner animation='border' size="sm" variant='primary' /></div>
                                    : <>
                                    {
                                        (ppvList && ppvList.length <= 0) ? <tr>
                                            <td colSpan={3} align='center'>
                                                No media found
                                            </td>
                                        </tr>
                                        : <>
                                            {
                                                ppvList.map((k, index) => (
                                                    <tr key={index}>
                                                        <td className="text_center cont_relative"><span
                                                            className="ppv_img_cont various-top-ppv"
                                                            style={{backgroundImage: `url('${s3Link}/${k.media_thumb}')`}}></span>
                                                        </td>
                                                        {
                                                            (ppvFilter == 'all_su') ? <td className="text_right">{currency(k.price).format({precision: 2})}</td>
                                                                : <>
                                                                    <td className="text_right">{currency(k.total_sum).format({precision: 2})}</td>
                                                                    <td className="text_right">{k.Qty}</td>
                                                                    <td className="text_right">{currency(k.price).format({precision: 2})}</td>
                                                                </>
                                                        }
                                                        <td className="text_center">{moment.utc(k.created_at).local().format('Y-MM-DD HH:mm A')}</td>
                                                    </tr>
                                                ))
                                            }
                                        </>
                                    }
                                </>
                            }
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </Modal.Body>
    </Modal>;
};

export default React.memo(PpvStatistics);
